/**
 * Confirm delete dialog — names the item being removed (#344 pattern).
 */
export default function DeleteConfirmDialog({
  open,
  itemName,
  onCancel,
  onConfirm,
}: {
  open: boolean
  itemName: string
  onCancel: () => void
  onConfirm: () => void
}) {
  if (!open) return null
  return (
    <div
      className="cm-dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cm-delete-title"
      data-testid="cm-delete-dialog"
      onClick={(e) => { if (e.target === e.currentTarget) onCancel() }}
    >
      <div className="cm-dialog-card">
        <h2 id="cm-delete-title">Delete this item?</h2>
        <p>
          Delete “{itemName}”? This removes it from the margin and, if unpaid, from the cash forecast.
        </p>
        <div className="cm-dialog-actions">
          <button type="button" className="cm-btn" onClick={onCancel} data-testid="cm-delete-cancel">
            Cancel
          </button>
          <button
            type="button"
            className="cm-btn cm-btn-danger"
            onClick={onConfirm}
            data-testid="cm-delete-confirm"
          >
            Delete item
          </button>
        </div>
      </div>
    </div>
  )
}
